import { useQuery, UseQueryResult } from 'react-query'

import type { AlertService } from 'features/alerts/service'
import type { SharedUsersResponse } from 'features/share/types'

export function useAlertSharedUsersQuery(
  alertService: AlertService,
  projectId: string,
  enabled: boolean = true,
): UseQueryResult<SharedUsersResponse> {
  return useQuery(
    ['shared-users', projectId],
    () => alertService.fetchSharedUsers(projectId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled,
    },
  )
}
